



















import { Vue, Component } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';
import BottomTabbar from './components/BottomTabbar.vue';
import { OPTHINES } from './config';
import { getType } from './api';

@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class First extends Vue {
  option = OPTHINES;
  TypeData = [];
  get source() {
    return this.$route.params.source;
  }
  created() {
    getType().then((res) => (this.TypeData = Object.values(res.data)));
    this.$appShareInfo({
      title:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      url: window.location.href,
      subtitle:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });

    this.$wxShareInfo({
      title:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      subtitle:
        '这是我参加第六届“紫荆杯”两岸暨港澳青少年书画大赛的作品，请为我点赞！',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  enterList(i: any) {
    if (this.$route.params.source) {
      this.$router.push({
        path: '../List',
        query: { type: i, source: this.source },
      });
    } else {
      this.$router.push({
        path: './List',
        query: { type: i },
      });
    }
  }
}
